import { ReactNode } from 'react';
import { Link } from '~/commonComponents';

const POPUP_CONFIGS: Record<PopupType, PopupConfig> = {
  psa: {
    title: 'Personnel Service Agreement',
    description:
      "Before posting a shift, please take a moment to review and accept GoTu's Personnel Service Agreement for the office you're posting on behalf of.",
    type: 'psa',
    links: [
      {
        text: "GoTu's Personnel Service Agreement",
        href: 'https://joingotu.com/w-2-psa/',
      },
    ],
  },
  gotuTerms: {
    title: 'Terms and Conditions',
    description:
      "Before posting a shift, please take a moment to review and accept GoTu's Terms and Conditions for the office you're posting on behalf of.",
    type: 'gotuTerms',
    links: [
      {
        text: "GoTu's Terms and Conditions",
        href: 'https://joingotu.com/client-terms-of-use/',
      },
    ],
  },
  both: {
    title: 'GoTu Policies',
    description:
      "Before posting a shift, please take a moment to review and accept GoTu's Policies for the office you're posting on behalf of.",
    type: 'both',
    links: [
      {
        text: "GoTu's Terms and Conditions",
        href: 'https://joingotu.com/client-terms-of-use/',
      },
      {
        text: 'Personnel Service Agreement',
        href: 'https://joingotu.com/w-2-psa/',
      },
    ],
  },
};

type PopupType = 'psa' | 'gotuTerms' | 'both';

interface PopupConfig {
  title: string;
  description: string;
  type: PopupType;
  links: { text: string; href: string }[];
}

const getPopupType = (isTCMissing: boolean, isPSAMissing: boolean): PopupType | null => {
  if (isTCMissing && isPSAMissing) return 'both';
  if (isTCMissing) return 'gotuTerms';
  if (isPSAMissing) return 'psa';

  return null;
};

const renderSwitchText = (type: PopupType, links: { text: string; href: string }[]): ReactNode => {
  if (type === 'both') {
    const [firstLink, secondLink] = links;
    if (firstLink && secondLink) {
      return (
        <>
          I agree to <Link text={firstLink.text} href={firstLink.href} /> and{' '}
          <Link text={secondLink.text} href={secondLink.href} />
        </>
      );
    }

    return <>I agree to</>;
  }

  const firstLink = links[0];
  if (firstLink) {
    return (
      <>
        I agree to <Link text={firstLink.text} href={firstLink.href} />
      </>
    );
  }

  return <>I agree to</>;
};
export { getPopupType, POPUP_CONFIGS, renderSwitchText };
